import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
  Divider,
} from '@mui/material'
import {
  Email,
  LocationOn,
  LinkedIn,
  Instagram,
} from '@mui/icons-material'
import siteConfig from '../config/siteConfig'

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              🚀 Propulsion Industries
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              From the laboratories of Mexico to international competition fields, we're pushing the boundaries of rocketry with innovative technology. Join us as we reach for the stars and beyond.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {siteConfig.footer.quickLinks.about && (
                <Link href="/about" color="inherit" underline="hover">
                  About Us
                </Link>
              )}
              {siteConfig.footer.quickLinks.projects && (
                <Link href="/projects" color="inherit" underline="hover">
                  Projects & Competitions
                </Link>
              )}
              {siteConfig.footer.quickLinks.contact && (
                <Link href="/contact" color="inherit" underline="hover">
                  Contact Us
                </Link>
              )}
              {/* Deactivated sections - ready to reactivate */}
              {/* {siteConfig.footer.quickLinks.sponsors && (
                <Link href="/sponsors" color="inherit" underline="hover">
                  Become a Sponsor
                </Link>
              )} */}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact Info
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email fontSize="small" />
                <Typography variant="body2">
                  hello@propulsion.industries
                </Typography>
              </Box>
              {/*<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone fontSize="small" />
                <Typography variant="body2">
                  +52 XXX XXX XXXX
                </Typography>
              </Box>*/}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn fontSize="small" />
                <Typography variant="body2">
                  Mexico
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" gutterBottom>
                Follow us:
              </Typography>
              <Box>
                <IconButton 
                  color="inherit" 
                  size="small"
                  component="a"
                  href="https://www.linkedin.com/company/propulsion-industries"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedIn />
                </IconButton>
                <IconButton 
                  color="inherit" 
                  size="small"
                  component="a"
                  href="https://www.instagram.com/propulsion_industries/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.2)' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} Propulsion Industries. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
